import * as React from "react";
import { useParams, useLocation, useNavigate, NavigateFunction, Location } from "react-router";


export interface IRouteContentProps {
    render: (router: IRouter) => React.ReactNode;
}

export interface IRouter {
    params: any;
    location: Location<any>;
    navigate: NavigateFunction;
}



export const RouteContent = (props: IRouteContentProps) => {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <>
            {props.render({ params: params, location: location, navigate: navigate })}
        </>
    );
};
